export function useMarketingModal({tracking, onOpen = () => {}, props, ...args} = {}) {
  if (!tracking?.type || !tracking?.context) {
    throw new Error('Marketing modals require tracking type and context.');
  }

  return useFModal({
    bgClass: 'bg-transparent',
    backdropClass: BACKDROP_BLUR_CLASS,
    roundedClass: 'rounded-2xl',
    closeButtonProps: {
      color: 'white',
      variant: 'ghost',
      ui: {
        color: {
          white: {
            ghost: 'text-white hover:bg-white/15'
          }
        }
      }
    },
    ...args,
    props: {
      ...props,
      upsellTracking: tracking
    },
    onOpen() {
      useGtm().trackEvent({
        event: 'core_ui-upsell_modal-open',
        action: 'open',
        category: 'upsell',
        upsell_type: tracking.type,
        upsell_context: tracking.context
      });
      onOpen.call(this);
    }
  });
}
